import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService, config } from '@fgb/core';
import { ProviderUiActionResponse } from '@fgb/core';
@Component({
  selector: 'fgb-ecash-result',
  templateUrl: 'ecash-result-page.component.html',
})
export class EcashResultPageComponent implements OnInit {
  response = new ProviderUiActionResponse();
  private paymentService = inject(PaymentService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  ngOnInit() {
    this.processCallBack();
  }

  processCallBack() {
    const purchaseOrderId = this.route.snapshot.queryParamMap.get('purchaseOrderId') || undefined;
    const orderId = this.route.snapshot.queryParamMap.get('orderId') || undefined;

    const callbackUrl = config.baseApiUrl + this.router.url;

    const params = {
      orderId,
      purchaseOrderId,
    };

    this.paymentService.completePayment(params, callbackUrl, '/cardtoken/success', '/cardtoken/failure');
  }
}
